const subscriptionFilters = {
    state: {
      filters: {}
    },
    mutations: {
      // Mutation to set a filter based on the label
      setFilter(state, { label, value }) {
        console.log(`Attempting to set filter for ${label} with value:`, value);
        // if (label in state.filters) {
          state.filters[label] = value;
          console.log(`Filter for ${label} set to:`, state.filters[label]);
        // } else {
        //   console.error(`Filter with label ${label} does not exist!`);
        // }
      },
      // Mutation to reset all filters
      resetFilters(state) {
        state.filters = { };
      }
    },
    actions: {
      // Action to apply a filter
      applyFilter({ commit }, { label, value }) {
        // Commit the mutation to update the filter
        commit('setFilter', { label, value });
      }
      ,
        // Action to reset all filters
        resetFilters({ commit }) {
        commit('resetFilters');
        }
    },
    getters: {
      // Getter to retrieve a specific filter value based on the label
      getFilter: (state) => (label) => {
        return state.filters[label] || null;
      }
    }
  };
  
  export default subscriptionFilters;
  